import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getHeaders() {
  const t = localStorage.getItem("bf_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// 402 = plan gate / trial expired. Redirect to pricing with the reason.
// EXCEPTION: `monthly_proposal_cap_reached` — the caller (OpportunityDetail.draft)
// intercepts this to pop the OverageDialog so the operator can accept the
// overage in-place instead of being punted to /pricing.
axios.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 402 && detail && typeof detail === "object") {
      const reason = detail.error || "paid_plan_required";
      const required = detail.required_plan || "professional";
      const path = window.location.pathname;
      if (
        path !== "/pricing" &&
        path !== "/credits" &&
        path !== "/login" &&
        path !== "/signup" &&
        reason !== "monthly_proposal_cap_reached"   // caller handles this locally
      ) {
        // credits_exhausted → route to the credits top-up page; anything else → pricing
        if (reason === "credits_exhausted") {
          window.location.href = `/credits?reason=exhausted`;
        } else {
          const search = new URLSearchParams({ reason, required }).toString();
          window.location.href = `/pricing?${search}`;
        }
      }
    }
    return Promise.reject(error);
  }
);

export const api = {
  get: (path, config = {}) => axios.get(`${API}${path}`, { withCredentials: true, ...config, headers: { ...getHeaders(), ...(config.headers || {}) } }),
  post: (path, data, config = {}) => axios.post(`${API}${path}`, data, { withCredentials: true, ...config, headers: { ...getHeaders(), ...(config.headers || {}) } }),
  put: (path, data, config = {}) => axios.put(`${API}${path}`, data, { withCredentials: true, ...config, headers: { ...getHeaders(), ...(config.headers || {}) } }),
  patch: (path, data, config = {}) => axios.patch(`${API}${path}`, data, { withCredentials: true, ...config, headers: { ...getHeaders(), ...(config.headers || {}) } }),
  del: (path, config = {}) => axios.delete(`${API}${path}`, { withCredentials: true, ...config, headers: { ...getHeaders(), ...(config.headers || {}) } }),
  // Alias so codebase can call either api.del or api.delete interchangeably.
  delete: (path, config = {}) => axios.delete(`${API}${path}`, { withCredentials: true, ...config, headers: { ...getHeaders(), ...(config.headers || {}) } }),
};
